/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

import Login from "../pages/login/login.vue";
import ResetPassowrd from "../pages/reset_password/reset_password.vue";
import Index from "../pages/index/index.vue";

import BusinessManage from "../pages/index/business_manage/index";
import BusinessOrganizationHospital from "../pages/index/business_manage/organization/hospital.vue";
import BusinessOrganizationAgent from "../pages/index/business_manage/organization/agent.vue";
import BusinessUserBacker from "../pages/index/business_manage/user_manage/backer.vue";
import BusinessUserProxyer from "../pages/index/business_manage/user_manage/proxyer.vue";
import BusinessUserHospitaler from "../pages/index/business_manage/user_manage/hospitaler.vue";
import BusinessUserGeneraler from "../pages/index/business_manage/user_manage/generaler.vue";
import BusinessAuthInfo from "../pages/index/business_manage/auth_info/auth_info.vue";
import BusinessSimSim from "../pages/index/business_manage/sim_manage/sim/sim.vue";
import BusinessIFStore from "../pages/index/business_manage/IF/store/store.vue";
import BusinessIFUser from "../pages/index/business_manage/IF/user/user.vue";

import BusinessIFUsageRecords from "../pages/index/business_manage/IF/UsageRecords/UsageRecords.vue";

import BusinessVisualDevice from "../pages/index/business_manage/visual_detection/detection_device/detection_device.vue";
import BusinessTrainerTrainer from "../pages/index/business_manage/online_trainer/trainer/trainer.vue";

import DataGovernance from "../pages/index/data_governance/index";
import DataGovernanceFinanceHospitalPage from "../pages/index/data_governance/finance_count/hospital.vue";
import DataGovernanceFinanceAgentPage from "../pages/index/data_governance/finance_count/agent.vue";
import DataGovernanceFinanceUserPage from "../pages/index/data_governance/finance_count/user.vue";
import DataGovernanceTrainingAbnormal from "../pages/index/data_governance/training_monitoring/training_abnormal.vue";
import DataGovernanceTrainingDate from "../pages/index/data_governance/training_monitoring/training_date.vue";
import DataGovernanceTrainingNumber from "../pages/index/data_governance/training_monitoring/training_number.vue";
import DataGovernanceTrainingAccount from "../pages/index/data_governance/training_monitoring/account.vue";
import DataGovernanceTrainingManager from "../pages/index/data_governance/training_monitoring/training_manager.vue";
import DataGovernanceTrainingMemo from "../pages/index/data_governance/training_monitoring/memo.vue";

import DatareportFormsAgentPage from "../pages/index/data_governance/report_forms/agent.vue"; //报表统计

import BackTools from "../pages/index/back_tools/index";
import BackToolsLoginType from "../pages/index/back_tools/tools/login_type.vue";
import BackToolsCard from "../pages/index/back_tools/tools/card.vue";
import BackToolsProductType from "../pages/index/back_tools/tools/product_type.vue";
import BackToolsPermission from "../pages/index/back_tools/tools/permission.vue";
import BackToolsIp from "../pages/index/back_tools/tools/ip.vue";
import BackToolsWebPrimary from "../pages/index/back_tools/tools/web/primary.vue";
import BackToolsWebSecondary from "../pages/index/back_tools/tools/web/secondary.vue";
import BackToolsLogTraining from "../pages/index/back_tools/tools/log/training.vue";
import BackToolsLogCost from "../pages/index/back_tools/tools/log/cost.vue";
import BackToolsLogUpdateTraining from "../pages/index/back_tools/tools/log/update_training.vue";
import BackToolsLogMallUnusual from "../pages/index/back_tools/tools/log/mall_unusual.vue";
import BackToolsLogRechargeAccount from "../pages/index/back_tools/tools/log/recharge_account.vue";
import BackToolsLogPrescription from "../pages/index/back_tools/tools/log/prescription.vue";
import BackToolsCustomerConditionManage from "../pages/index/back_tools/tools/customer/condition/condition.vue";
import BackToolsCustomerManage from "../pages/index/back_tools/tools/customer/customer/customer.vue";
import BackToolsLoginCount from "../pages/index/back_tools/tools/login_count.vue";
import BackToolsExcelList from "../pages/index/back_tools/excel/list/list.vue";
import BackToolsExcelRecord from "../pages/index/back_tools/excel/record.vue";

import BusinessCardManage from "../pages/index/business_manage/card_system/manage/manage.vue";
import BusinessCardGenerate from "../pages/index/business_manage/card_system/generate/generate.vue";
import TransferOutRecord from "../pages/index/business_manage/card_system/TransferOutRecord/TransferOutRecord.vue";

import OperationManage from '../pages/index/operation_manage/index.vue';
import OperationUserAccountRenewalCheck from '../pages/index/operation_manage/user_manage/account_renewal_check.vue';
import OperationTrainerMaster from '../pages/index/operation_manage/trainer_manage/master';
import OperationTaskCutOff from '../pages/index/operation_manage/task_indicator/cut_off/cut_off.vue';

import Application from '../pages/index/application/index.vue';
import AppMerchantMerchant from '../pages/index/application/app/merchant_manage/merchant/merchant.vue';
import AppShopGoods from '../pages/index/application/app/shop_manage/goods/goods.vue';
import AppShopOrders from '../pages/index/application/app/shop_manage/orders/orders.vue';
import AppShopDisease from '../pages/index/application/app/shop_manage/disease/disease.vue';
import AppArticles from '../pages/index/application/app/article_manage/articles/articles.vue';
import AppArticleTypes from '../pages/index/application/app/article_manage/types/types.vue';
import AppArticleProblems from '../pages/index/application/app/article_manage/problems/problems.vue';
import AppSwiperHome from '../pages/index/application/app/swiper_manage/home/home.vue';
import AppInfoHot from '../pages/index/application/app/info_manage/hot/hot.vue';
import IAssistantBanner from '../pages/index/application/i_assistant/banner/banner.vue';
import IAssistantCard from '../pages/index/application/i_assistant/card/card.vue';
import IAssistantSort from '../pages/index/application/i_assistant/sort/sort.vue';
import IAssistantCase from '../pages/index/application/i_assistant/case/case.vue';
import IAssistantCommunity from '../pages/index/application/i_assistant/community/community.vue';
import IAssistantCourse from '../pages/index/application/i_assistant/course/course.vue';
import IAssistantKnowledge from '../pages/index/application/i_assistant/knowledge/knowledge.vue';
import IAssistantIntegralExchange from '../pages/index/application/i_assistant/integral/exchange/exchange.vue';
import IAssistantIntegralRecords from '../pages/index/application/i_assistant/integral/records/records.vue';
import MallShopGoods from '../pages/index/application/mall/shop_manage/goods/goods.vue';
import MallShopOrder from '../pages/index/application/mall/shop_manage/order/order.vue';
import MallShopDisease from '../pages/index/application/mall/shop_manage/disease/disease.vue';
//  隐美视
import businessLens from '../pages/index/business_manage/lens/index';
import applicationLens from '../pages/index/application/lens/index';
// 赠送用户
import BusinessUserGift from "../pages/index/business_manage/user_manage/gift.vue";


const BUSINESS_MANAGE_ROUTES = [{
	// 业务管理
	path: "/index/business_manage",
	component: BusinessManage,
	children: [{
			path: '/index/business_manage/organization_hospital',
			component: BusinessOrganizationHospital
		}, {
			path: '/index/business_manage/organization_agent',
			component: BusinessOrganizationAgent
		}, {
			path: '/index/business_manage/user_backer',
			component: BusinessUserBacker
		}, {
			path: '/index/business_manage/user_proxyer',
			component: BusinessUserProxyer
		}, {
			path: '/index/business_manage/user_hospitaler',
			component: BusinessUserHospitaler
		}, {
			path: '/index/business_manage/user_generaler',
			component: BusinessUserGeneraler
		},
		{
			path: '/index/business_manage/user_gift',
			component: BusinessUserGift
		},
		{
			path: '/index/business_manage/auth_info',
			component: BusinessAuthInfo
		}, {
			path: '/index/business_manage/sim_sim',
			component: BusinessSimSim
		}, {
			path: '/index/business_manage/IF_store',
			component: BusinessIFStore
		}, {
			path: '/index/business_manage/IF_user',
			component: BusinessIFUser
		}, {
			path: '/index/business_manage/IF_UsageRecords',
			component: BusinessIFUsageRecords
		}, {
			path: '/index/business_manage/visual_device',
			component: BusinessVisualDevice
		}, {
			path: '/index/business_manage/trainer_trainer',
			component: BusinessTrainerTrainer
		}, {
			path: '/index/business_manage/card_manage',
			component: BusinessCardManage
		}, {
			path: '/index/business_manage/card_generate',
			component: BusinessCardGenerate
		}, {
			path: '/index/business_manage/TransferOutRecord',
			component: TransferOutRecord
		},
		// 隐美视
		{
			path: '/index/business_manage/lens',
			component: businessLens,

		},
		{
			path: '/index/business_manage',
			redirect: '/index/business_manage/auth_info'
		}, {
			path: '/index/business_manage/*',
			redirect: '/index/business_manage/auth_info'
		},

	]
}];
const DATA_GOVERNANCE_ROUTES = [{
	path: "/index/data_governance",
	component: DataGovernance,
	children: [{
		path: '/index/data_governance/finance_hospital',
		component: DataGovernanceFinanceHospitalPage
	}, {
		// DatareportFormsAgentPage
		path: '/index/data_governance/finance_agent',
		component: DataGovernanceFinanceAgentPage
	}, {
		path: '/index/data_governance/finance_user',
		component: DataGovernanceFinanceUserPage
	}, {
		// DatareportFormsAgentPage报表统计
		path: '/index/data_governance/report_agent',
		component: DatareportFormsAgentPage
	}, {
		path: '/index/data_governance/training_abnormal',
		component: DataGovernanceTrainingAbnormal
	}, {
		path: '/index/data_governance/training_date',
		component: DataGovernanceTrainingDate
	}, {
		path: '/index/data_governance/training_number',
		component: DataGovernanceTrainingNumber
	}, {
		path: '/index/data_governance/training_account',
		component: DataGovernanceTrainingAccount
	}, {
		path: '/index/data_governance/training_manager',
		component: DataGovernanceTrainingManager
	}, {
		path: '/index/data_governance/training_memo',
		component: DataGovernanceTrainingMemo
	}, {
		path: '/index/data_governance',
		redirect: '/index/data_governance/finance_hospital'
	}, {
		path: '/index/data_governance/*',
		redirect: '/index/data_governance/finance_hospital'
	}]
}];
const BACK_TOOLS_ROUTES = [{
	path: "/index/back_tools",
	component: BackTools,
	children: [{
		path: '/index/back_tools/login_type',
		component: BackToolsLoginType
	}, {
		path: '/index/back_tools/card',
		component: BackToolsCard
	}, {
		path: '/index/back_tools/product_type',
		component: BackToolsProductType
	}, {
		path: '/index/back_tools/permission',
		component: BackToolsPermission
	}, {
		path: '/index/back_tools/ip',
		component: BackToolsIp
	}, {
		path: '/index/back_tools/web_primary',
		component: BackToolsWebPrimary
	}, {
		path: '/index/back_tools/web_secondary',
		component: BackToolsWebSecondary
	}, {
		path: '/index/back_tools/log_training',
		component: BackToolsLogTraining
	}, {
		path: '/index/back_tools/log_cost',
		component: BackToolsLogCost
	}, {
		path: '/index/back_tools/log_update_training',
		component: BackToolsLogUpdateTraining
	}, {
		path: '/index/back_tools/log_mall_unusual',
		component: BackToolsLogMallUnusual
	}, {
		path: '/index/back_tools/log_recharge_account',
		component: BackToolsLogRechargeAccount
	}, {
		path: '/index/back_tools/log_prescription',
		component: BackToolsLogPrescription
	}, {
		path: '/index/back_tools/customer_condition_manage',
		component: BackToolsCustomerConditionManage
	}, {
		path: '/index/back_tools/customer_manage',
		component: BackToolsCustomerManage
	}, {
		path: '/index/back_tools/login_count',
		component: BackToolsLoginCount
	}, {
		path: '/index/back_tools/excel_list',
		component: BackToolsExcelList
	}, {
		path: '/index/back_tools/excel_record',
		component: BackToolsExcelRecord
	}, {
		path: '/index/back_tools',
		redirect: '/index/back_tools/login_type'
	}, {
		path: '/index/back_tools/*',
		redirect: '/index/back_tools/login_type'
	}]
}];
const OPERATION_MANAGE = [{
	path: "/index/operation_manage",
	component: OperationManage,
	children: [{
		path: '/index/operation_manage/user_account_renewal_check',
		component: OperationUserAccountRenewalCheck
	}, {
		path: '/index/operation_manage/trainer_master',
		component: OperationTrainerMaster
	}, {
		path: '/index/operation_manage/task_cutOff',
		component: OperationTaskCutOff
	}, {
		path: '/index/operation_manage',
		redirect: '/index/operation_manage/user_account_renewal_check'
	}, {
		path: '/index/operation_manage/*',
		redirect: '/index/operation_manage/user_account_renewal_check'
	}]
}];
const APPLICATION_MANAGE = [{
	path: "/index/application",
	component: Application,
	children: [{
			path: '/index/application/app/merchant_merchant',
			component: AppMerchantMerchant
		}, {
			path: '/index/application/app/shop_goods',
			component: AppShopGoods
		}, {
			path: '/index/application/app/shop_orders',
			component: AppShopOrders
		}, {
			path: '/index/application/app/shop_disease',
			component: AppShopDisease
		}, {
			path: '/index/application/app/articles',
			component: AppArticles
		}, {
			path: '/index/application/app/article_types',
			component: AppArticleTypes
		}, {
			path: '/index/application/app/article_problems',
			component: AppArticleProblems
		}, {
			path: '/index/application/app/swiper_home',
			component: AppSwiperHome
		}, {
			path: '/index/application/app/info_hot',
			component: AppInfoHot
		}, {
			path: '/index/application/i_assistant/banner',
			component: IAssistantBanner
		}, {
			path: '/index/application/i_assistant/card',
			component: IAssistantCard
		}, {
			path: '/index/application/i_assistant/sort',
			component: IAssistantSort
		}, {
			path: '/index/application/i_assistant/case',
			component: IAssistantCase
		}, {
			path: '/index/application/i_assistant/community',
			component: IAssistantCommunity
		}, {
			path: '/index/application/i_assistant/course',
			component: IAssistantCourse
		}, {
			path: '/index/application/i_assistant/knowledge',
			component: IAssistantKnowledge
		}, {
			path: '/index/application/i_assistant/integral_exchange',
			component: IAssistantIntegralExchange
		}, {
			path: '/index/application/i_assistant/integral_records',
			component: IAssistantIntegralRecords
		}, {
			path: '/index/application/mall/shop_goods',
			component: MallShopGoods
		}, {
			path: '/index/application/mall/shop_order',
			component: MallShopOrder
		}, {
			path: '/index/application/mall/shop_disease',
			component: MallShopDisease
		},
		{
			path: '/index/application/lens_order',
			component: applicationLens
		},
		{
			path: '/index/application',
			redirect: '/index/application/app/merchant_merchant'
		}, {
			path: '/index/application/*',
			redirect: '/index/application/app/merchant_merchant'
		}
	]
}];
/******************************* 导出数据 ********************************/
export default new Router({
	mode: "history",
	routes: [{
			path: "/index",
			component: Index
		},
		...BUSINESS_MANAGE_ROUTES,
		...DATA_GOVERNANCE_ROUTES,
		...BACK_TOOLS_ROUTES,
		...OPERATION_MANAGE,
		...APPLICATION_MANAGE,
		{
			path: "/login",
			component: Login,
			meta: {
				keepAlive: false
			}
		}, {
			path: "/reset_password",
			component: ResetPassowrd,
			meta: {
				keepAlive: false
			}
		}, {
			path: '/index/*',
			redirect: '/index'
		}, {
			path: '*',
			redirect: '/index'
		}
	]
})